'use strict';

var React = require('react');
//Components
var Investor = require('./Investor.jsx');
//Stores
var YourDetailsStore = require('../../stores/YourDetailsStore');

function getStateFromStores() {
    return {
        titleList: YourDetailsStore.getTitleList(),
        errorList: YourDetailsStore.getErrorList(),
        tfnExemptionList: YourDetailsStore.getTfnExemptionList(),
        yourDetailsData: YourDetailsStore.getYourDetailsData()
    };
}

var Individual = React.createClass({

    getInitialState: function () {
        return getStateFromStores();
    },

    // Add change listeners to stores
    componentDidMount: function () {
        YourDetailsStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        YourDetailsStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    render: function () {
        return (
            <Investor data={this.state.yourDetailsData} 
                      productId={this.props.productId}
                      accountType={this.props.accountType}
                      titleList={this.state.titleList} 
                      tfnExemptionList={this.state.tfnExemptionList}
                      errorList={this.state.errorList} />
        );
    }
});

/// This is the entry point for individual account type.
/// Super and pension can be added here, but they are already in testing.

module.exports = Individual;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Individual.jsx